import { getQaAxiosClient, getQaConfiguration } from "./saludV2Client";

export async function getConvocatoriaContext(id) {
  if (!/^[1-9]\d*$/.test(String(id))) throw new Error("Indique una convocatoria valida.");
  const config = getQaConfiguration();
  let auth;
  try { auth = JSON.parse(localStorage.getItem("token") || "null")?.idToken; } catch (_) { /* No usable session. */ }
  if (!auth) {
    const error = new Error("Inicie sesion nuevamente.");
    error.status = 401;
    throw error;
  }
  const response = await getQaAxiosClient(config).get(`/salud/v2/atenciones/contexto-convocatoria/${id}`, {
    headers: { Authorization: `Bearer ${auth}`, "x-access-token": auth },
  });
  const context = response.data?.data?.convocatoria;
  if (String(context?.id) !== String(id)) throw new Error("No se pudo confirmar la convocatoria.");
  return context;
}

export function contextDefaults(context) {
  const text = value => typeof value === "string" ? value : "";
  const rawDate = text(context?.fecha);
  const date = /^\d{4}-\d{2}-\d{2}$/.test(rawDate) &&
    Number.isFinite(Date.parse(`${rawDate}T00:00:00Z`)) &&
    new Date(`${rawDate}T00:00:00Z`).toISOString().slice(0, 10) === rawDate ? rawDate : null;
  return {
    estado: text(context?.geografia?.estado), municipio: text(context?.geografia?.municipio),
    parroquia: text(context?.geografia?.parroquia), centro: text(context?.comunidad), fecha: date,
  };
}

export function contextErrorMessage(error) {
  const status = error?.response?.status || error?.status;
  if (status === 401) return "Inicie sesion nuevamente para consultar la convocatoria.";
  if (status === 403) return "No tiene permiso para consultar esta convocatoria.";
  if (status === 404) return "Contexto no disponible: compruebe el acceso y la publicacion del backend de contexto.";
  return "No se pudo consultar el contexto de la convocatoria. Compruebe la conexion.";
}

export function resolveContextFields(values, defaults, touched, record) {
  return Object.fromEntries(Object.entries(values).map(([key, value]) =>
    [key, record || touched[key] ? value : defaults[key]]));
}
